import React from 'react'
import Blog from '../components/Blog'

function BlogPage() {
  return (
    <div>
       <div className="main">
      <p>My Blog</p>
      </div>
      <Blog />
    </div>
  )
}

export default BlogPage
